import AXIOS from './util'

const state = {
  list: []
}

const mutations = {
  LIST (state, value) {
    state.list = value
  },
  SET (state, value) {
    state.list.filter(item => {
      if (item.id === value.id) {
        const i = state.list.indexOf(item)
        state.list[i] = value
      }
    })
  }
}

const actions = {
  INIT ({ state, commit, dispatch }) {
    dispatch('LOAD')
  },
  SET_LIST ({ state, commit }, value) {
    commit('LIST', value)
  },
  LOAD ({ state, commit, dispatch }) {
    AXIOS.get('/bookings')
      .then((response) => {
        dispatch('SET_LIST', response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  NEW ({ state, commit, dispatch }, value) {
    AXIOS.post('/bookings', [value])
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  SAVE ({ state, commit, dispatch }, value) {
    AXIOS.put('/bookings', value)
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  DELETE ({ state, commit, dispatch }, id) {
    AXIOS.delete(`/bookings/${id}`)
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  GET ({ state, commit, dispatch }, id) {
    AXIOS.get(`/bookings/${id}`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response.data
      })
  },
  CHECK ({ state, commit, dispatch }, value) {
    return AXIOS.get('/bookings/check-is-busy', { params: value })
      .then((response) => response.data)
      .catch((error) => {
        // Keep a consistent rejection payload for callers
        const payload = error?.response?.data ?? error
        return Promise.reject(payload)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
